var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelPrintFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M17.777 4.027c.664-.13 1.223.221 1.223.79v9.313c0 .57-.548 1.136-1.223 1.269l-1.766.345v3.528c0 .52-.469.832-1.052.696l-7.906-1.84C6.47 17.994 6 17.464 6 16.943V7.364c0-.57.548-1.137 1.223-1.27Zm-3.56 12.066-4.452.88 4.451 1.066zm-.427-3.644-4.791.852a.65.65 0 0 0-.54.757.67.67 0 0 0 .783.522l4.79-.852a.65.65 0 0 0 .54-.757.67.67 0 0 0-.782-.522m2.261-3.141-7.095 1.26a.65.65 0 0 0-.54.757.67.67 0 0 0 .783.522l7.095-1.26a.65.65 0 0 0 .54-.758.67.67 0 0 0-.783-.521m-.033-2.676L8.923 7.893a.65.65 0 0 0-.54.757.67.67 0 0 0 .783.522l7.095-1.26a.65.65 0 0 0 .54-.758.67.67 0 0 0-.783-.522"
})));
export default SvgGemChannelPrintFilled;